/* ============================================================
   TRP CAROUSEL TOUCH
   carousel-touch.js

   Direction-locked swipe detector for carousels.

   Attaches touchstart/touchmove/touchend listeners to an element
   and calls onSwipeLeft / onSwipeRight only when:
   - The gesture is primarily horizontal (not vertical scroll)
   - The horizontal travel exceeds the swipe threshold
   - Optional isActive() gate passes (e.g. only on mobile)
   - Optional shouldSkip() gate passes (e.g. not mid-transition)

   Usage:
     window.TRPCarouselTouch.attach(element, {
       onSwipeLeft: function () { carousel.next(); },
       onSwipeRight: function () { carousel.prev(); },
       isActive: function () { return window.innerWidth < 768; }, // optional
       shouldSkip: function () { return el.classList.contains('is-transitioning'); }, // optional
       threshold: 40, // optional, default 40 (min px of horizontal travel to trigger)
       lockThreshold: 10 // optional, default 10 (px before direction is locked)
     });
   ============================================================ */

(function () {
  'use strict';

  if (window.TRPCarouselTouch) return; // already loaded

  function noop() { return false; }
  function always() { return true; }

  function attach(element, options) {
    if (!element) return;

    var onSwipeLeft  = options.onSwipeLeft  || noop;
    var onSwipeRight = options.onSwipeRight || noop;
    var isActive     = options.isActive     || always;
    var shouldSkip   = options.shouldSkip   || noop;
    var threshold    = typeof options.threshold === 'number' ? options.threshold : 40;
    var lockThreshold = typeof options.lockThreshold === 'number' ? options.lockThreshold : 10;

    var startX = 0;
    var startY = 0;
    var direction = null; // null | 'horizontal' | 'vertical'

    element.addEventListener('touchstart', function (e) {
      if (!isActive()) return;
      startX = e.changedTouches[0].screenX;
      startY = e.changedTouches[0].screenY;
      direction = null;
    }, { passive: true });

    element.addEventListener('touchmove', function (e) {
      if (!isActive()) return;
      if (direction !== null) return; // already locked
      var dx = Math.abs(e.changedTouches[0].screenX - startX);
      var dy = Math.abs(e.changedTouches[0].screenY - startY);
      if (dx < lockThreshold && dy < lockThreshold) return;
      direction = dx > dy ? 'horizontal' : 'vertical';
    }, { passive: true });

    element.addEventListener('touchend', function (e) {
      if (!isActive()) return;
      if (shouldSkip()) return;
      if (direction !== 'horizontal') return;
      var diff = e.changedTouches[0].screenX - startX;
      if (Math.abs(diff) < threshold) return;
      if (diff < 0) {
        onSwipeLeft();
      } else {
        onSwipeRight();
      }
    }, { passive: true });
  }

  window.TRPCarouselTouch = { attach: attach };
})();
